import ContentLoader from './ContentLoader'

export default ContentLoader
